import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow"

import { authModel } from "src/store/authModel";
import { userModel } from "src/store/userModel";

export function useTokenMiddleware() {
    const accessToken = authModel(useShallow(state => state.accessToken))
    const {emailVerified, id} = userModel(useShallow(state => state))
    const navigate = useNavigate();

    useEffect(() => {
        if (!accessToken) {
            navigate('/sign-in', { replace: true })
        }
        return () => {}
    }, [accessToken, navigate])

    useEffect(() => {
        if (!emailVerified && id) {
            navigate('/verify-email', { replace: true })
        }
        return () => {}
    }, [emailVerified, id, navigate])
}